import { useState } from "react";
import RandomVoucher from "./RandomVoucher"; // Assuming RandomVoucher is exported as default from this file

const RandomVoucherWithLogin = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = () => {
        if (password === "aod") {
            setIsAuthenticated(true);
        } else {
            setError("Invalid password. Please try again.");
        }
    };

    if (!isAuthenticated) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-100">
                <div className="w-96 bg-white shadow-lg rounded-lg p-6">
                    <h1 className="text-2xl font-bold text-center text-gray-800 mb-4">
                        Unlock Screen
                    </h1>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError(""); // Clear error when user types
                            }}
                            className="w-full px-3 py-2 border rounded-md shadow-sm focus:ring focus:ring-indigo-200 text-black"
                            placeholder="Enter your password"
                        />
                    </div>
                    {error && (
                        <p className="text-red-500 text-sm mb-4">{error}</p>
                    )}
                    <button
                        onClick={handleLogin}
                        className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700 transition"
                    >
                        Login
                    </button>
                </div>
            </div>
        );
    }

    return <RandomVoucher />;
};

export default RandomVoucherWithLogin;
